import { render } from "./questionCreate.vue?vue&type=template&id=4b295647&scoped=true"
import script from "./questionCreate.vue?vue&type=script&lang=js"
export * from "./questionCreate.vue?vue&type=script&lang=js"

import "./questionCreate.vue?vue&type=style&index=0&id=4b295647&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b295647"]])

export default __exports__